import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bar-horizontal",
  "use": "icon-bar-horizontal-usage",
  "viewBox": "0 0 1072 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1072 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bar-horizontal\"><defs><style type=\"text/css\"></style></defs><path d=\"M150.528 77.482667v207.286857H623.177143l2.998857-207.286857zM1023.853714 380.830476H150.528v207.286857h867.791238zM820.711619 684.178286H150.528v207.286857h665.916952z\" p-id=\"1375\" /><path d=\"M115.151238 943.079619V0.146286h-41.203809v994.377143h996.10819v-51.44381H115.151238z\" p-id=\"1376\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol